import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./About.scss";
import { urlFor, client } from "../../client";

import { NavigationDots, SocialMedia } from "../../components";

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => setAbouts(data));
  }, []);

  return (
    <>
      <div id="about" className="app__container app__whitebg">
        <SocialMedia />

        <div className="app__wrapper app__flex">
          <motion.div
            whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
            transition={{ duration: 0.5 }}
            className={`app__about app__flex`}
          >
            <h2 className="head-text">
              I Know that <span>Good Development</span> meant <br />
              <span>Good Business</span>
            </h2>

            <div className="aboutDiv">
              <div>
                Hi, I am Sumeet, nice to meet you. Please take a look around.
              </div>
              <div>
                Right now I am looking for better opportunity, I have great
                experience of over 2 years in Full Stack Web Development. Also,
                I started building some projects to get a job opportunity.
              </div>
            </div>
            {/* <div className="app__profiles">
              {abouts.map((about, index) => (
                <motion.div
                  whileInView={{ opacity: 1 }}
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 0.5, type: "tween" }}
                  className="app__profile-item"
                  key={about.title + index}
                >
                  <img src={urlFor(about.imgUrl)} alt={about.title} />
                  <h2 className="bold-text" style={{ marginTop: 20 }}>
                    {about.title}
                  </h2>
                  <p className="p-text" style={{ marginTop: 10 }}>
                    {about.description}
                  </p>
                </motion.div>
              ))}
            </div> */}
          </motion.div>
        </div>
        <NavigationDots active="about" />
      </div>
    </>
  );
};

export default About;
